/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  JasperCommercialRestService,
  JasperServerDto,
  JasperServerStatus,
} from '@gh/builder-shared-data';
import { DictionaryService, InitDialogViewService } from '@gh/common-shared';
import { DialogRouteSnapshot, EmptyDialogInput } from '@gh/core-ui';
import { Observable } from 'rxjs';

export type JasperServer = JasperServerDto;

@Injectable()
export class JcDetailsDialogBusinessService implements InitDialogViewService<EmptyDialogInput> {
  constructor(private dictionaries: DictionaryService,
              private jcRest: JasperCommercialRestService) {

  }

  initDialogView(route?: DialogRouteSnapshot<EmptyDialogInput>): any {
    return {
      jasperServerStatusDict: this.dictionaries.getByEnum(JasperServerStatus),
      details: this.status(),
    };
  }

  status(): Observable<JasperServer> {
    return this.jcRest.status();
  }

  turnOn(): Observable<JasperServer> {
    return this.jcRest.turnOn();
  }

  turnOff(): Observable<JasperServer> {
    return this.jcRest.turnOff();
  }
}
